import styled, { keyframes } from "styled-components";
import { colors } from "../element/elements.js";

// Animation keyframes
const zoomAnimation = keyframes`
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
`;

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 0.7;
    }
`;

export const Styles = styled.div`
    .breadcrumb-area {
        background-size    : cover;
        background-position: center;
        background-repeat  : no-repeat;
        position           : relative;
        animation          : ${zoomAnimation} 20s ease-in-out infinite;
        
        &:before {
            position        : absolute;
            content         : '';
            background      : ${colors.bg1};
            opacity         : 0.7; /* Lower opacity */
            width           : 100%;
            height          : 100%;
            top             : 0;
            left            : 0;
            animation       : ${fadeIn} 2s ease-in-out;
        }

        .breadcrumb-box {
            background      : rgba(255, 255, 255, 0.1); /* Semi-transparent background */
            backdrop-filter : blur(10px); /* Glass effect */
            display         : inline-block;
            padding         : 30px 45px;
            border-radius   : 15px;
            border          : 1px solid rgba(255, 255, 255, 0.2);
            animation       : ${fadeIn} 1.5s ease-in-out;

            h2.breadcrumb-title {
                color         : #ffffff;
                font-weight   : 600;
                text-transform: uppercase;
                margin-bottom : 5px;
                text-shadow   : 2px 2px 4px rgba(0, 0, 0, 0.5);

                @media(max-width: 767px) {
                    font-size : 20px;
                }
            }

            nav {
                ol.breadcrumb {
                    display         : inline-flex;
                    padding         : 0;
                    margin-bottom   : 0;
                    background-color: transparent;
                    border-radius   : 0;

                    li.breadcrumb-item {
                        a {
                            color: ${colors.green};
                            text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);

                            &:hover {
                                color: #ffffff;
                                transform: translateY(-2px);
                                transition: all 0.3s ease;
                            }
                        }
                    }

                    li.breadcrumb-item.active {
                        color: ${colors.border3};
                        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);

                        &::before {
                            color: ${colors.border3};
                        }
                    }
                }
            }
        }

        @media(max-width: 767px) {
            .breadcrumb-box {
                padding: 20px 30px;
                margin: 0 15px;
            }
        }
    }
`;